import type { SliceI18nManifest } from '@/shared/lib/vsa';
import cs from './locales/cs.json';
import en from './locales/en.json';

const NS = 'security';

export const securityI18nManifest: SliceI18nManifest = {
  owner: 'modules/security',
  namespaces: [NS],
  resources: {
    cs: { [NS]: cs },
    en: { [NS]: en },
  },
};
